module.exports = __webpack_public_path__ + "static/media/Decentral solar.4f538428.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Decentral solar.svg
// module id = 186
// module chunks = 0